import { AuditType } from "../models/enums/AuditTypes";
import { ISearchingTag, TagName, TagType } from "./../../../shared/components/tag-searching-input/~types/models/SearchingTag";
import { ConvertFromAuditStatus } from "src/app/audit/helpers/audit-helper"
import i18n from "src/app/shared/localization/i18n";

export const LOAD_AUDITS_COUNT = 20;

export const getAuditSearchingTags = (): ISearchingTag[] => [
    { 
        id: 1,
        value: i18n.t("common.date"),
        suggestions: ["2", "3"],
        tagType: TagType.OpeningTag,
        tagName: TagName.Date
    },
    { 
        id: 2,
        value: "=",
        tagType: TagType.OperationTag
    },
    {
        id: 3,
        tagName: TagName.Date,
        value: "",
        suggestions: [
            i18n.t('common.today'),
            i18n.t('common.yesterday'),
            i18n.t('common.currentWeek'),
            i18n.t('common.currentMonth'),
            i18n.t('common.currentYear'),
            i18n.t('common.period')
        ],
        tagType: TagType.ClosingTag
    },
    { 
        id: 4,
        value: i18n.t("common.type"),
        suggestions: ["5", "6"],
        tagType: TagType.OpeningTag,
        tagName: TagName.Status
    },
    { 
        id: 5,
        value: "=",
        tagType: TagType.OperationTag
    },
    {
        id: 6,
        tagName: TagName.Status,
        value: "",
        suggestions:  Object.keys(AuditType).filter((v) => isNaN(Number(v))).map(status => ConvertFromAuditStatus(AuditType[status as keyof typeof AuditType])),
        tagType: TagType.ClosingTag
    },
    {
        id: 7,
        tagName: TagName.Operator,
        value: i18n.t('common.operator'),
        suggestions: ["5", "8"],
        tagType: TagType.OpeningTag,
    },
    {
        id: 8,
        tagName: TagName.Operator,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag,
    },
]